import FirmApi from '../../services/FirmApi'
import ApiService from '@/services/ApiService'

export const firm = {
    namespaced: true,
    state: {
        ares_data: {
            ico: '',
            dic: '',
            firma: '',
            ulice: '',
            cislo: '',
            mesto: '',
            psc: '',
            kod_okresu: '',
            kod_obce: '',
            kod_casti_obce: '',
            kod_ulice: '',
            lat: 0,
            lon: 0,
            id_adresy: '',
            adrupresneni: '',
        },
        form_data: {
            email: '',
            telefon: '',
            www: '',
            popis: '',
        },
        presentation: {
            id: 0,
            name: '',
            services: [],
            isActive: false,
            price_per_year: 0,
            buttonValue: '',
        },
        result: {
            id_firmy: 0,
            hashid: '',
            id_uzivatele: 0,
            hashuid: null,
            opravny_kod: '',
        },
        order_options: {
            payment_method: 0,
        },
    },
    mutations: {
        /*
        setFirmAll(state, payload) {
            state.id_firmy = payload.id_firmy;
            state.ares_data = payload.ares_data;
            state.form_data = payload.form_data;
            state.presentation = payload.presentation;
            state.result = payload.result;
        },

         */
        setAresData(state, payload) {
            state.ares_data = payload
        },
        setFormData(state, payload) {
            state.form_data = payload
        },
        setPresentation(state, payload) {
            state.presentation = payload
        },
        setResult(state, payload) {
            state.result = payload
        },
        setOrderOptions(state, order_options) {
            state.order_options = order_options
        },
    },
    actions: {
        /*
        setFirmAll({ commit }, payload) {
            commit('setFirmAll', payload)
        },
        */

        /**
         * vrací true, pokud je IČO již registrované nebo false
         * @param dispatch
         * @param ico
         * @returns {Promise<any>}
         */
        isIcoRegistered({ dispatch }, ico) {
            dispatch('loader/setLoader', 'Načítám registrované firmy ...', {
                root: true,
            })

            return new Promise((resolve, reject) => {
                FirmApi.fetchRegisteredFirms(ico)
                    .then(function(response) {
                        dispatch('loader/setLoader', '', { root: true })

                        const { results, status } = response.data
                        if (!status) {
                            resolve(false)
                        }
                        // nalezeny firmy s IČO
                        if (results.length > 0) {
                            resolve(true)
                        } else {
                            resolve(false)
                        }
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        },
        /**
         * vrací údaje o firmě ze systému ARES
         * @param commit
         * @param dispatch
         * @param ico
         */
        getAresData({ commit }, ico) {
            return new Promise((resolve, reject) => {
                ApiService.fetchAres(ico)
                    .then(function(response) {
                        console.log(response)

                        const {
                            ico,
                            dic,
                            firma,
                            ulice,
                            cislo,
                            mesto,
                            psc,
                            kod_okresu,
                            kod_obce,
                            kod_casti_obce,
                            kod_ulice,
                            lat,
                            lon,
                            id_adresy,
                            adrupresneni,
                        } = response.data.results.response

                        if (!ico) {
                            resolve(false)
                        }

                        commit('setAresData', {
                            ico,
                            dic,
                            firma,
                            ulice,
                            cislo,
                            mesto,
                            psc,
                            kod_okresu,
                            kod_obce,
                            kod_casti_obce,
                            kod_ulice,
                            lat,
                            lon,
                            id_adresy,
                            adrupresneni,
                        })
                        resolve(true)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /*
        setFormData({ commit }, payload) {
            commit('setFormData', payload)
        },
        */
        /*
        setPresentation({ commit }, payload) {
            commit('setPresentation', payload)
        },
        */
        /**
         * vytvoří firmu
         * @param commit
         * @param dispatch
         * @param state
         * @param rootState
         * @returns {Promise<any>}
         */
        setFirm({ commit, state, rootState }) {
            return new Promise((resolve, reject) => {
                // development mock pro testovani bez API
                /*
                if (process.env.NODE_ENV == 'development') {
                    console.log(
                        'v development env neukldama firmu, vracim fake udaje!'
                    )
                    commit('setResult', {
                        id_firmy: 5000000,
                        hashid: 'e5bb90831ea67dd49e026e17cd32d60b',
                        id_uzivatele: '314165',
                        hashuid: '',
                        opravny_kod: '2d99532ba898b61754bee9649',
                    })
                    resolve(true)
                    return
                }
                */
                //-----------------------------------------

                // ulozi firmu na backendu
                FirmApi.createFirm(
                    state.ares_data,
                    state.form_data,
                    state.presentation,
                    rootState.config.crm,
                    rootState.config.sandbox
                )
                    .then(function(response) {
                        const {
                            id_firmy,
                            hashid,
                            id_uzivatele,
                            hashuid,
                            opravny_kod,
                            error,
                        } = response.data.results

                        // pri chybe ulozeni zobrazi chybu a skonci
                        if (error != undefined) {
                            reject(error)
                        }

                        // po uspesnem ulozeni na backendu ulozi do store vytvorene id_firmy, opravny_kod atd.

                        commit('setResult', {
                            id_firmy,
                            hashid,
                            id_uzivatele,
                            hashuid,
                            opravny_kod,
                        })

                        // jeste kontrola, zda backend vratil id_firmy a hashid
                        if (
                            typeof state.result.id_firmy === 'undefined' ||
                            state.result.hashid === 'undefined'
                        ) {
                            reject(
                                'Chyba: Došlo k interní chybě, firma nebyla správně uložena (opravny_kod je prázdný)!'
                            )
                        }
                        resolve(true)
                        // vm.currentStep = "thanks";
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        },
        /**
         * provede operace po uložení firmy
         * @param dispatch
         * @param state
         * @param rootState
         * @returns {Promise<any>}
         */
        executeAfterSaveActions({ dispatch, state, rootState }) {
            return new Promise((resolve, reject) => {
                // after save actions -----------------------------

                // development mock pro testovani bez API
                /*
                if (process.env.NODE_ENV == 'development') {
                    console.log(
                        'v development env neprovadim AfterSaveActions !'
                    )
                    resolve(true)
                    return
                }
                */
                //-----------------------------------------

                // replikace do CRM
                //file_get_contents('http://kancelar.marten-louis.cz/pts/replikace/ceskyseznam2crm.html?id=' . $stav['id'] . '&kod=' . $stav['hash']);
                dispatch('loader/setLoader', 'Zapisuji firmu do CRM', {
                    root: true,
                })
                FirmApi.executeScriptCeskyseznam2CRM(
                    state.result.id_firmy,
                    state.result.opravny_kod,
                    rootState.config.sandbox
                )
                    .then(function(response) {
                        // console.log(response)
                        const results = response.data.results
                        if (results == 1) {
                            dispatch(
                                'loader/setLoader',
                                'Aktualizuji katalog firem',
                                {
                                    root: true,
                                }
                            )
                            // doplneni adresare firmy, nebudu cekat response
                            FirmApi.executeScriptAdresare(
                                state.result.id_firmy
                            ).then(function(response) {
                                // console.log(response)
                            })
                            // insert do firmy_neblokovane, nebudu cekat response
                            FirmApi.executeScriptFirmyNeblokovaneTabulky(
                                state.result.id_firmy
                            ).then(function(response) {
                                // console.log(response)
                                dispatch('loader/setLoader', '', {
                                    root: true,
                                })
                            })
                            resolve(true)
                        } else {
                            reject('nepodařilo se vytvořit firmu v CRM')
                        }
                    })
                    .catch(function(error) {
                        reject(error)
                    })

                // -------------------------------------------------
            })
        },

        setOfferRequest({ dispatch, state, rootState }) {
            return new Promise((resolve, reject) => {
                dispatch(
                    'loader/setLoader',
                    'Zapisuji žádost o nabídku do CRM',
                    {
                        root: true,
                    }
                )
                FirmApi.setOfferRequest(
                    rootState.config.crm,
                    state.result.id_firmy,
                    state.result.opravny_kod,
                    rootState.config.sandbox
                )
                    .then(function(response) {
                        dispatch('loader/setLoader', '', {
                            root: true,
                        })

                        resolve(true)
                    })
                    .catch(function(error) {
                        reject(error)
                    })
            })
        },
    },
}
